export const dataUrlToBlob = (dataUrl) => {
  const [header, base64] = dataUrl.split(',');
  const mimeMatch = header.match(/data:(.*?);base64/);
  const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mime });
};

const loadImage = (blob) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });

const canvasToBlob = (canvas, type, quality) =>
  new Promise((resolve) => {
    canvas.toBlob((b) => resolve(b), type, quality);
  });

export const resizeImageToWidth = async (fileOrBlob, targetWidth = 300, outputType) => {
  const inputBlob = fileOrBlob instanceof Blob ? fileOrBlob : new Blob([fileOrBlob], { type: fileOrBlob?.type });
  const img = await loadImage(inputBlob);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const width = img.naturalWidth || img.width;
  const height = img.naturalHeight || img.height;
  const scale = targetWidth / Math.max(1, width);
  const nextWidth = Math.max(1, Math.round(width * scale));
  const nextHeight = Math.max(1, Math.round(height * scale));

  canvas.width = nextWidth;
  canvas.height = nextHeight;
  ctx.drawImage(img, 0, 0, nextWidth, nextHeight);

  const type = outputType || inputBlob.type || 'image/jpeg';
  return canvasToBlob(canvas, type, type === 'image/jpeg' ? 0.92 : 0.95);
};

export const compressImageUnderBytes = async (fileOrBlob, targetBytes = 1024 * 1024) => {
  const inputBlob = fileOrBlob instanceof Blob ? fileOrBlob : new Blob([fileOrBlob], { type: fileOrBlob?.type });

  if ((fileOrBlob?.size || inputBlob.size) <= targetBytes) {
    return inputBlob;
  }

  const img = await loadImage(inputBlob);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  let width = img.naturalWidth || img.width;
  let height = img.naturalHeight || img.height;

  const maxSide = 1920;
  const scale = Math.min(1, maxSide / Math.max(width, height));
  width = Math.round(width * scale);
  height = Math.round(height * scale);

  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(img, 0, 0, width, height);

  let quality = 0.92;
  let blob = await canvasToBlob(canvas, 'image/jpeg', quality);

  while (blob && blob.size > targetBytes && quality > 0.4) {
    quality -= 0.08;
    blob = await canvasToBlob(canvas, 'image/jpeg', quality);
  }

  if (blob && blob.size > targetBytes) {
    const ratio = Math.sqrt(targetBytes / blob.size);
    const w2 = Math.max(1, Math.floor(width * ratio));
    const h2 = Math.max(1, Math.floor(height * ratio));
    const canvas2 = document.createElement('canvas');
    const ctx2 = canvas2.getContext('2d');
    canvas2.width = w2;
    canvas2.height = h2;
    ctx2.drawImage(canvas, 0, 0, w2, h2);
    blob = await canvasToBlob(canvas2, 'image/jpeg', Math.max(0.5, quality));
  }

  return blob || inputBlob;
};
